import { useState } from "react";
import { Link } from "react-router-dom";
import PrimaryButton from "../../../../components/Button/PrimaryButton";
import AuthFormLayout from "../../../../components/Auth/AuthFormLayout";
import AuthField from "../../../../components/Auth/AuthField";
import api from "../../../../utils/axiosInstance";
import { AUTH_MESSAGES } from "../../../../utils/constants/authMessages";

const validateEmail = (email) => {
  if (!email) return "Email is required.";
  if (!/\S+@\S+\.\S+/.test(email)) return "Enter a valid email address.";
  return "";
};

const RequestReset = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [serverError, setServerError] = useState("");
  const [success, setSuccess] = useState("");

  const handleBlur = () => setError(validateEmail(email));

  const handleChange = (e) => {
    setEmail(e.target.value);
    setError("");
    setServerError("");
    setSuccess("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateEmail(email);
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      const res = await api.post("/auth/request-reset", { email });
      setSuccess(res.data.message || AUTH_MESSAGES.resetRequested);
      setServerError("");
    } catch (err) {
      // The server answers the same way for known and unknown emails, so anything
      // short of an unreachable server keeps that neutral message.
      if (err.response) {
        setSuccess(AUTH_MESSAGES.resetRequested);
        setServerError("");
      } else {
        setServerError("Something went wrong. Please try again.");
        setSuccess("");
      }
    }
  };

  return (
    <AuthFormLayout
      title="Reset Password"
      subtitle="Enter your email and we will send you a reset link."
      error={serverError}
      success={success}
      onSubmit={handleSubmit}
      footer={
        <p className="text-center text-xs font-medium text-gray-500">
          Remembered it?{" "}
          <Link to="/login" className="font-bold text-brand-600 hover:underline">
            Log In
          </Link>
        </p>
      }
    >
      <AuthField
        name="email"
        label="Email"
        type="email"
        placeholder="Enter your email"
        autoComplete="username"
        value={email}
        error={error}
        onChange={handleChange}
        onBlur={handleBlur}
      />

      <PrimaryButton type="submit">Send Reset Link</PrimaryButton>
    </AuthFormLayout>
  );
};

export default RequestReset;
